import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Text,
  useToast,
} from '@chakra-ui/react'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { api } from '../../../services/api'
import { useMutation } from 'react-query'

const schema = z.object({
  codigo_usuario: z.string().nonempty(),
  senha_usuario: z.string().nonempty(),
  nome_liberador: z.string().nonempty(),
  ativo: z.boolean().transform((v) => (v ? 'S' : 'N')),
  ativo_liberador: z.boolean().transform((v) => (v ? 'S' : 'N')),
})

async function createUser({
  codigo_usuario,
  senha_usuario,
  nome_liberador,
  ativo,
  ativo_liberador,
}) {
  const response = await api.post(
    '/site/v2/fluxo-liberacao/atualizar-dados-liberador',
    {
      codigo_usuario,
      senha_usuario,
      nome_liberador,
      ativo,
      ativo_liberador,
    },
  )

  return response.data
}

export function CriarUsuario() {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  })

  const toast = useToast({
    duration: 3000,
    isClosable: true,
    position: 'top',
  })

  async function handleSave(data) {
    try {
      await mutateAsync(data)
    } catch (error) {
      console.error(error)
    }
  }

  const { data, mutateAsync, isLoading } = useMutation({
    mutationFn: createUser,
    onSuccess: () => {
      toast({
        title: 'Usuário criado com sucesso',
        status: 'success',
      })
    },
    onError: (error) => {
      toast({
        title: 'Erro ao criar usuário',
        description: error.message,
        status: 'error',
      })
    },
  })

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      as="form"
      onSubmit={handleSubmit(handleSave)}
      maxW="400px"
      w="100%"
      mx="auto"
      mt="10"
    >
      <Text
        fontSize="lg"
        fontWeight="bold"
        textAlign="center"
        color="gray.700"
        mb={4}
      >
        Criar Usuário
      </Text>
      <FormControl>
        <FormLabel>Nome liberador</FormLabel>
        <Input
          {...register('nome_liberador')}
          placeholder="Nome liberador"
          isInvalid={!!errors.nome_liberador}
        />
      </FormControl>

      <FormControl>
        <FormLabel>Código usuário</FormLabel>
        <Input
          {...register('codigo_usuario')}
          placeholder="Código usuário"
          isInvalid={!!errors.codigo_usuario}
        />
      </FormControl>

      <FormControl>
        <FormLabel>Senha usuário</FormLabel>
        <Input
          {...register('senha_usuario')}
          type="password"
          placeholder="Senha usuário"
          isInvalid={!!errors.senha_usuario}
        />
      </FormControl>

      <Flex alignItems="center" justifyContent="space-between">
        <FormControl display="flex" gap={2} alignItems="center">
          <FormLabel m="0">Ativo</FormLabel>
          <Checkbox {...register('ativo')} isInvalid={!!errors.ativo} />
        </FormControl>

        <FormControl display="flex" gap={2} alignItems="center">
          <FormLabel m="0">Ativo liberador</FormLabel>
          <Checkbox
            {...register('ativo_liberador')}
            isInvalid={!!errors.ativo_liberador}
          />
        </FormControl>
      </Flex>
      <Button
        type="submit"
        colorScheme="blue"
        isLoading={isLoading}
        loadingText="Criando Usuário"
      >
        Criar Usuário
      </Button>
    </Box>
  )
}
